export default "__VITE_ASSET__gCrNAU87__"